<script setup lang="ts">
  import { useMaintenance } from "@/lib/native/useMaintenance"
  import { Alert, AlertDescription } from "@/components/ui/alert"
  import { Link } from "@/components/ui/link"

  const { isNativeMaintenanceBannerEnabled, maintenanceBannerContent } =
    useMaintenance()
</script>

<template>
  <Alert
    v-if="isNativeMaintenanceBannerEnabled"
    variant="warning"
    :title="maintenanceBannerContent?.title ?? 'App under maintenance'"
    data-testid="maintenance-alert"
  >
    <AlertDescription>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div
        v-if="maintenanceBannerContent?.message"
        v-html="maintenanceBannerContent.message"
      ></div>
      <div v-else>
        We are doing some essential maintenance on our app. We apologise for any
        inconvenience this may cause. To submit a read or make a payment please
        try again soon or use our
        <Link
          to="https://soenergy.typeform.com/to/Qc8BF7Oa"
          class="link text-sm"
          >meter reading form</Link
        >.
      </div>
    </AlertDescription>
  </Alert>
</template>
